import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.main`
  width: 100%;
  flex: 1;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;

  &.content-appear,
  &.content-enter {
    opacity: 0;
  }

  &.content-appear-active,
  &.content-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    max-width: 1048px;
  }
`;
